import { render } from "./SankeyChart.vue?vue&type=template&id=0b96eb56&scoped=true"
import script from "./SankeyChart.vue?vue&type=script&lang=js"
export * from "./SankeyChart.vue?vue&type=script&lang=js"

import "./SankeyChart.vue?vue&type=style&index=0&id=0b96eb56&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b96eb56"]])

export default __exports__